var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeeks2UErrorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 65,
    viewBox: "0 0 62 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_37889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2086 0C41.0183 0 35.2182 5.84808 35.2182 12.9904V16.9211H26.3023C24.8642 11.3606 19.7831 7.28613 13.7912 7.28613C6.60093 7.28613 0.800781 13.0863 0.800781 20.2765C0.800781 27.4668 6.64886 33.267 13.7912 33.267C19.7351 33.267 24.8163 29.1445 26.3023 23.632H35.1702V27.5627C35.1702 34.7529 40.9704 40.5531 48.1607 40.5531C55.3509 40.5531 61.1511 34.705 61.1511 27.5627V13.0383C61.1511 5.89602 55.3989 0 48.2086 0ZM13.7433 26.604C10.244 26.604 7.41583 23.7279 7.41583 20.2765C7.41583 16.7773 10.244 13.9491 13.7433 13.9491C17.2425 13.9491 20.0707 16.8252 20.0707 20.2765C20.0707 23.7758 17.2425 26.604 13.7433 26.604ZM54.4881 27.5627C54.4881 31.0619 51.6599 33.8901 48.1607 33.8901C44.6614 33.8901 41.8332 31.0619 41.8332 27.5627V13.0383C41.8332 9.53908 44.6614 6.71091 48.1607 6.71091C51.6599 6.71091 54.4881 9.53908 54.4881 13.0383V27.5627Z",
    fill: "#DA192E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9998 36.814C23.2343 36.814 16.9548 43.0935 16.9548 50.8589C16.9548 58.6244 23.2343 64.9039 30.9998 64.9039C38.7653 64.9039 45.0448 58.6244 45.0448 50.8589C45.0448 43.0935 38.7174 36.814 30.9998 36.814ZM30.9998 58.912C26.5419 58.912 22.9467 55.3169 22.9467 50.8589C22.9467 46.401 26.5419 42.8059 30.9998 42.8059C35.4578 42.8059 39.0529 46.401 39.0529 50.8589C39.0529 55.3169 35.4578 58.912 30.9998 58.912Z",
    fill: "#DA192E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_411_37889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.3982,
    height: 65,
    fill: "white",
    transform: "translate(0.800781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeeks2UErrorLogo);
export default __webpack_public_path__ + "static/media/geeks2u-error-logo.bc79a0c80ad12b570108256f4e7b7068.svg";
export { ForwardRef as ReactComponent };